export default {
  path: 'product-category',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    {
      path: '',
      name: 'ProductCategoryList',
      component: () => import('@/views/settingSystem/pages/product-category/ProductCategoryList.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'create',
      name: 'ProductCategoryCreate',
      component: () => import('@/views/settingSystem/pages/product-category/ProductCategoryCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'edit/:id',
      name: 'ProductCategoryEdit',
      component: () => import('@/views/settingSystem/pages/product-category/ProductCategoryEdit.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }
  ]
}
